import constants from '../../../../config/WelcomeConstants';
export const  products= constants.products_products;